module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1r2r7r4r-9054acf9896bfdacb368a0a49de87852.svg";